export default class {
  _rfc = ''
  _razonSocial = ''
  _serialNumber = ''
  _algorithm = ''

  constructor(rfc, razonSocial, serialNumber, algorithm) {
    this._rfc = rfc
    this._razonSocial = razonSocial
    this._serialNumber = serialNumber
    this._algorithm = algorithm
  }

  get rfc() {
    return this._rfc
  }

  get razonSocial() {
    return this._razonSocial
  }

  get serialNumber() {
    return this._serialNumber
  }

  get algorithm() {
    return this._algorithm
  }
}
